import { RESETTABLE_MODAL_SCREENS } from "./constants";

export const isResettableScreen = screenName =>
  RESETTABLE_MODAL_SCREENS.includes(screenName);
